import { useState } from 'react';
import { DocumentTypeClient, DocumentTypeDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useDocumentTypeApi = () => {
    const apiClient = new DocumentTypeClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: DocumentTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createDocumentType(data);
        } catch (err: any) {
            setError(err.message || 'Error creating DocumentType');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: DocumentTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateDocumentType(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating DocumentType');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getDocumentTypeById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching DocumentType');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchDocumentTypes(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching DocumentTypes');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteDocumentType(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting DocumentType');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};